module.exports = "<p>\n  ussd-payment works!\n</p>\n"